import { useQuery } from '@tanstack/react-query';

import { CustomerService } from '../../services';
import { handleNucleusResponse } from '../../services/utils';

export const useCurrentCustomer = (businessId: string | undefined) => {
  const QUERY_KEY = ['currentCustomer', businessId];
  const query = useQuery({
    queryKey: QUERY_KEY,
    queryFn: async () => {
      if (!businessId) {
        throw new Error('No outlet selected');
      }
      const response = await CustomerService.getCurrentCustomer(businessId);
      return handleNucleusResponse(response).data;
    },
    enabled: !!businessId,
  });

  const { data: currentCustomer, isLoading, ...restQuery } = query;
  return {
    currentCustomer,
    isLoading,
    ...restQuery,
  };
};
